import { makeHttpClient, _unwrapAxiosResponse } from "./http";

import env from "../environment/env.json";

function dateFormatter(dt: Date) {
  if (dt != null) {
    return dt.toLocaleDateString("fr-CA");
  }
  return dt;
}
export class AnalyticsService {
  private httpClient = makeHttpClient();

  getReportTrackerOnTimeVsLate(year: number, customer_id: any) {
    let url = `${env.analyticsUrl}report/ontime/late/?year=${year}`;
    if (customer_id) {
      url = `${url}&customer_id=${customer_id}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  getReportTrackerResubmittedReport(
    year: number,
    customer_id: any,
    start_date: any,
    end_date: any
  ) {
    let url = `${env.analyticsUrl}report/resubmitted/?year=${year}`;
    if (customer_id) {
      url = `${url}&customer_id=${customer_id}`;
    }
    if (start_date) {
      url = `${url}&actual_submission_start_date=${start_date}`;
    }
    if (end_date) {
      url = `${url}&actual_submission_end_date=${end_date}`;
    }

    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  getReportTrackerTotalCountReport(year: number, customer_id: any) {
    let url = `${env.analyticsUrl}report/total/count/?year=${year}`;
    if (customer_id) {
      url = `${url}&customer_id=${customer_id}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  getReportPerCountryStream(
    customer_id: any,
    start_date: any,
    end_date: any,
    country_list: any
  ) {
    let url = `${env.analyticsUrl}report/per/country/stream/?year=2021`;

    if (customer_id) {
      url = `${url}&customer_id=${customer_id}`;
    }
    if (start_date) {
      url = `${url}&start_date=${start_date}`;
    }
    if (end_date) {
      url = `${url}&end_date=${end_date}`;
    }
    if (country_list.length > 0 || country_list == -1) {
      url = `${url}&country_list=${country_list}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  getReportTrackerCount(
    year: number,
    customer_id: any,
    start_date: any,
    end_date: any
  ) {
    let url = `${env.analyticsUrl}report/count/?year=${year}`;
    if (customer_id) {
      url = `${url}&customer_id=${customer_id}`;
    }
    if (start_date) {
      url = `${url}&start_date=${start_date}`;
    }
    if (end_date) {
      url = `${url}&end_date=${end_date}`;
    }

    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  getReportDaysBeforeDeadline(
    customer_id: any,
    start_date: any,
    end_date: any,
    country_list: any,
    stream_list: any
  ) {
    let url = `${env.analyticsUrl}report/days/before/deadline/?year=2021}`;

    if (customer_id) {
      url = `${url}&customer_id=${customer_id}`;
    }
    if (start_date) {
      url = `${url}&start_date=${start_date}`;
    }
    if (end_date) {
      url = `${url}&end_date=${end_date}`;
    }
    if (country_list.length > 0 || country_list == -1) {
      url = `${url}&country_list=${country_list}`;
    }
    if (stream_list.length > 0 || stream_list == -1) {
      url = `${url}&stream_list=${stream_list}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }
}

export default AnalyticsService;
